<template>
  <v-container>
    <reactive-base
      app="elements"
      :url="apiUri"
      :headers="{ authorization: `Bearer ${this.$keycloak.token}` }"
    >
      <v-row>
        <v-col cols="12" sm="4">
          <v-card class="pa-7">
            <data-search
              componentId="Numéro d'inventaire"
              title="Numéro d'inventaire"
              data-field="inventoryNumber"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
              :customQuery="
                (value) => ({
                  query: {
                    wildcard: {
                      inventoryNumber: `*${value}*`,
                    },
                  },
                })
              "
            />
            <data-search
              componentId="Désignation"
              title="Désignation"
              data-field="name"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              queryFormat="and"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
            />
            <data-search
              componentId="Numéro de série"
              title="Numéro de série"
              data-field="businessId"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              queryFormat="and"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
            />
            <data-search
              componentId="Numéro de facture"
              title="Numéro de facture"
              data-field="billingId"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              queryFormat="and"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
            />
            <data-search
              componentId="Numéro de bon de commande"
              title="Numéro de bon de commande"
              data-field="orderId"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              queryFormat="and"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
            />
            <data-search
              componentId="Fournisseur"
              title="Fournisseur"
              data-field="supplier"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              queryFormat="and"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
            />
            <data-search
              componentId="Type"
              title="Type"
              data-field="type"
              :fuzziness="0"
              :size="10"
              :debounce="100"
              :URLParams="true"
              :autosuggest="false"
              queryFormat="and"
              class="my-7"
              placeholder="Rechercher..."
              :innerClass="innerClass"
            />
            <single-list
              componentId="Emplacement"
              data-field="place.name.raw"
              title="Emplacement"
              :react="react"
              sortBy="asc"
              :showSearch="false"
              class="my-7"
              :URLParams="true"
            />
            <multi-list
              componentId="Marque"
              data-field="brand.raw"
              title="Marques"
              :react="react"
              sortBy="asc"
              :showSearch="false"
              class="my-7"
              :URLParams="true"
              :size="1000"
            />
            <single-list
              componentId="Année"
              data-field="addedDate"
              title="Année"
              :react="react"
              sortBy="desc"
              :size="1000"
              :showSearch="false"
              class="my-7"
              :URLParams="true"
              :transformData="transformData"
              :customQuery="customQuery"
            />
            <multi-list
              componentId="Catégories"
              data-field="category.name.raw"
              title="Catégories"
              :react="react"
              sortBy="asc"
              :showSearch="false"
              class="my-7"
              :URLParams="true"
              :size="1000"
            />
            <multi-list
              componentId="Fournisseurs"
              data-field="supplier.raw"
              title="Fournisseurs"
              :react="react"
              sortBy="asc"
              :showSearch="false"
              class="my-7"
              :URLParams="true"
              :size="1000"
            />
          </v-card>
        </v-col>
        <v-col cols="12" sm="8">
          <v-card class="pa-7">
            <div class="text-right">
              <v-btn text @click="exportCurrent" color="grey darken-1">
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </div>
            <div class="subtitle">Résultats de la recherche</div>
            <selected-filters />
            <reactive-list
              componentId="ReactiveList"
              :react="react"
              data-field="inventoryNumber"
              sort-by="asc"
              @queryChange="queryChange"
            >
              <div slot="renderItem" slot-scope="{ item }">
                <v-card
                  class="my-5"
                  @click="$router.push(`/elements/${item._id}`)"
                  :color="item.deletedDate ? 'grey lighten-3' : ''"
                >
                  <v-card-title>
                    {{ item.name }}
                    <v-spacer />
                    <v-tooltip left v-if="item.group">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ item.group.name }}</span>
                    </v-tooltip>
                  </v-card-title>
                  <v-card-subtitle>{{ item.inventoryNumber }}</v-card-subtitle>
                </v-card>
              </div>
            </reactive-list>
          </v-card>
        </v-col>
      </v-row>
    </reactive-base>
  </v-container>
</template>

<script>
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  data: () => ({
    apiUri: process.env.VUE_APP_API_URI,
    react: {
      and: [
        "Marque",
        "Désignation",
        "Numéro d'inventaire",
        "Numéro de série",
        "Numéro de facture",
        "Numéro de bon de commande",
        "Fournisseur",
        "Fournisseurs",
        "Type",
        "Catégories",
        "Emplacement",
        "Année",
      ],
    },
    innerClass: {
      title: "text-title",
      input: "text-input",
    },
    currentQuery: {},
  }),
  methods: {
    exportCurrent: async function () {
      const { data } = await axios({
        method: "post",
        url: `${process.env.VUE_APP_API_URI}/generate-xls`,
        data: {
          ...this.currentQuery,
        },
        responseType: "arraybuffer",
      });
      fileDownload(data, "file.xlsx");
    },
    queryChange: function (prevQuery, nextQuery) {
      this.currentQuery = nextQuery;
    },
    transformData: function (data) {
      let result = [];
      data.map((d) => {
        result[d.key.split("-")[0]] = {
          key: d.key.split("-")[0],
          doc_count: data.filter(
            (f) => f.key.split("-")[0] === d.key.split("-")[0]
          ).length,
        };
      });
      return result.flatMap((f) => f).sort((a, b) => b.key - a.key);
    },
    customQuery: function (query) {
      if (query) {
        return {
          query: {
            range: {
              addedDate: {
                gte: `${query}-01-01`,
                lte: `${query}-12-31`,
              },
            },
          },
        };
      } else {
        return {
          query: {},
        };
      }
    },
  },
};
</script>